/**
 * Convert locale
 *
 * Convierte un string en locale al formato BD
 *
 * @Deprecated
 * @DISCLAIMER: Trasladamos los idiomas ISO a como están en BD (Se hicieron mal al importarlos en nuestra BD, habría que haber usado formato ISO con columnas idioma_id)
 * @param      {string}  strin   The string to convert
 */
// window.convertLocale = function (strin) {
//     let strout = 'cas';
//
//     switch (strin) {
//         case 'eu':
//             strout = 'eus';
//             break;
//         case 'ca':
//             strout = 'cat';
//             break;
//     }
//
//     return strout;
// };

/**
 * Parsea, ordena y obtiene el par atributo valor formateado en el idioma consultado
 *
 * @param    array    atributos_valores
 * @return   array    Atributos y valores
 */
window.parseAtributoValor = function (atributos_valores) {
    let atributo_valor_local_array = [];

    $.each(atributos_valores, function (atributo_valor, count) {
        let atributo_valor_local_json      = transformDynamicFacetValue(atributo_valor);
        atributo_valor_local_json.cantidad = count;
        atributo_valor_local_array.push(atributo_valor_local_json);
    });

    atributo_valor_local_array.sort(function (a, b) {
        return a.orden - b.orden;
    });

    return atributo_valor_local_array;
}

window.agruparPorAtributo = function (atributo_valor_local) {
    let grupos = {};
    $.each(atributo_valor_local, function (index, obj) {
        let atributo = obj.atributo;
        if (grupos[atributo] === undefined) {
            grupos[atributo] = [];
        }
        grupos[atributo].push(obj);
    });

    let matriz = [];
    $.each(grupos, function (atributo, objetos) {
        matriz.push(objetos);
    });

    return matriz;
}

window.transformFacetValue = function (facet, value) {

    switch (facet) {
        case 'materia_' + locale:
            return `${value.substring(value.lastIndexOf('|') + 1)}`;
            break;
        case 'asignatura_' + locale:
            return `${value.substring(value.lastIndexOf('|') + 1)}`;
            break;
        case 'nivel_educativo_' + locale:
            return `${value.substring(value.lastIndexOf('|') + 1)}`;
            break;
        case 'comunidad_' + locale:
            return `${value.substring(value.lastIndexOf('|') + 1)}`;
            break;
        case 'tipo':
            return `${transArticuloTipoValores[value]}`;
            break;
        case 'novedades':
            return `${ucfirst(transFechaRangos[value])}`;
            break;
        case 'campana_nombre_string':
            if (value.split('-').length > 1) {
                return `${value.split('-')[1].slice(0, -1)}`;
            } else {
                return `${value}`;
            }
            break;
        case 'situacion_titulo':
            let situacion_valor_array = value.split('|');
            switch (locale) {
                case 'eu':
                    return `${situacion_valor_array[0]}`;
                    break;
                case 'es':
                    return `${situacion_valor_array[1]}`;
                    break;
                case 'ca':
                    return `${situacion_valor_array[2]}`;
                    break;
                case 'gl':
                    return `${situacion_valor_array[3]}`;
                    break;
                case 'va':
                    return `${situacion_valor_array[4]}`;
                    break;
                default:
                    return `${situacion_valor_array[0]}`;
                    break;
            }
        default:
            return `${value}`;
            break;
    }
}

window.transformDynamicFacetValue = function (atributo_valor) {
    let atributo_valor_array  = atributo_valor.split('|');
    let nombre_atributo_array = atributo_valor_array[1].split('#');

    // @DISCLAIMER: Se tienen en cuenta diferentes casuísticas por no haber formalizado en solr los nombres de los atributos dinámicos. Cada uno está de una manera!
    let orden = 0;
    let nombre_atributo_local;
    // Posición en la que se encuentra el nombre del atributo solicitado en caso de tener el orden establecido
    let i     = 1;
    // Posición en la que se encuentra el nombre del atributo solicitado en caso de NO tener el orden establecido
    let j     = 0;

    // @DISCLAIMER: Trasladamos los idiomas ISO a como están en BD (Se hicieron mal al importarlos en nuestra BD, habría que haber usado formato ISO con columnas idioma_id)
    switch (locale) {
        // default:
        // case 'es':
        // case 'en':
        //     i = 1;
        //     j = 0;
        //     break;
        case 'eu':
            i = 2;
            j = 1;
            break;
        case 'ca':
            i = 3;
            j = 2;
            break;
        case 'gl':
            i = 4;
            j = 3;
            break;
        case 'va':
            i = 5;
            j = 4;
            break;
    }

    switch (nombre_atributo_array.length) {
        case 1:
            nombre_atributo_local = nombre_atributo_array[0];
            break;
        case 2:
            orden                 = parseInt(nombre_atributo_array[0]);
            nombre_atributo_local = nombre_atributo_array[1];
            break;
        case 3:
            // Si el atributo no trae el idioma solicitado, se muestra en castellano
            nombre_atributo_local = nombre_atributo_array[j] ?? nombre_atributo_array[0];
            break;
        default: // > 3
            orden                 = parseInt(nombre_atributo_array[0]);
            // Si el atributo no trae el idioma solicitado, se muestra en castellano
            nombre_atributo_local = nombre_atributo_array[i] ?? nombre_atributo_array[1];
            break;
    }

    let valor = atributo_valor_array[2];

    return {
        'atributo': nombre_atributo_local,
        'valor':    valor,
        'orden':    orden,
        'original': atributo_valor,
    }
}
